import script from "./TagSettingsSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./TagSettingsSummary.vue?vue&type=script&setup=true&lang=js"

import "./TagSettingsSummary.vue?vue&type=style&index=0&id=3da76a72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da76a72"]])

export default __exports__